<template>
  <section class="ui-end-game" :class="{ 'ui-end-game--app' : $inApp }">
    <div class="ui-end-game__banner">
      <img src="/img/misc/banner.png" alt="Banner game over">
    </div>

    <div class="ui-end-game__content" :class="{ 'ui-end-game__content--app' : $inApp }">
      <AppCurrentScore class="ui-end-game__score" />

      <ShareButton class="content__share" v-if="$inApp || (!$inApp && !isTouchDevice)" />

      <ScoreTable
        class="content__table"
        theme="white"
        v-if="$inApp && $isLogged"
      />

      <RoundedButton
        class="content__button"
        :content="$translate('start')"
        action="playAgain"
      />
    </div>

  </section>
</template>

<script>
import AppCurrentScore from '@/components/AppCurrentScore.vue';
import ShareButton from '@/components/ShareButton.vue';
import RoundedButton from '@/components/RoundedButton.vue';
import ScoreTable from '@/components/ScoreTable.vue';
import { isTouchDevice } from '@/scripts/utils';

export default {
  name: 'UIendGame',

  components: {
    AppCurrentScore,
    ShareButton,
    RoundedButton,
    ScoreTable,
  },

  data() {
    return {
      isTouchDevice: isTouchDevice(),
    };
  },

  mounted() {
    if (this.$inApp && this.$isLogged) {
      this.$store.dispatch('saveUserScore', this.$store.state.score);
    }
  },
};
</script>

<style lang="scss" scoped>
.ui-end-game {
  text-align: center;
  color: $white;

  @include gradient-bg(0.85);
  @extend %background-grain;

  &,
  &__banner,
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__banner {
    position: absolute;
    top: 20px;
    width: 200%;
    left: -40%;

    img {
      width: 100%;
      max-width: unset;
    }
  }

  &__content {
    position: relative;
    height: 100%;
    padding-top: 15vh;

    .content__share,
    .content__table,
    .content__button {
      position: relative;
      margin-top: 3vh;
    }

    .content__button {
      margin-top: 8vh;
    }

    &.ui-end-game__content--app .content__button {
      margin-bottom: -10vh;
    }
  }

  &__cookie {
    position: absolute;
    bottom: 20px;
    width: 100%;
    color: $white;
  }

  @include mq(ipadP) {
    &__banner {
      top: 8vh;
      width: 100%;
      left: 3.5%;

      img {
        width: 95%;
      }
    }
  }

  @include mq(d) {
    &__banner {
      top: 8vh;
      width: 100%;
      left: 3.5%;

      img {
        width: 65%;
      }
    }
  }
}
</style>
